import * as React from 'react';
import * as styles from './styles.css';
interface IAdfoxLayoutProps {
  children: React.ReactNode;
}

export function AdfoxLayout({ children }: IAdfoxLayoutProps) {
  return <div className={styles['container']}>{children}</div>;
}
